module.exports = __webpack_public_path__ + "img/pethouse10.a334ac8c.jpg";